import React, { useEffect } from "react";
import Chart from "react-apexcharts";
import { MoonLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import {
  retrieveGoalDisplay,
  setGoalType,
  changeOverviewModal,
  setActiveUpdateGoal,
  resetGoalDisplay,
} from "../../../../../redux/actions/overview";
import moment from "moment";
import "./style.scss";
import Text from "../../../../library/text";

const options = {
  chart: {
    type: "radialBar",
    stacked: true,
  },
  series: [67],
  colors: ["#20E647"],
  plotOptions: {
    radialBar: {
      startAngle: -95,
      endAngle: 95,
      track: {
        background: "#F5F5F5",
        startAngle: -95,
        endAngle: 95,
      },
      dataLabels: {
        name: {
          show: true,
          offsetY: -20,
          fontFamily: "Questrial",
          color: "#9c9c9c",
          fontSize: "14px",
        },
        value: {
          fontSize: "18px",
          fontFamily: "NexaBold",
          fontWeight: 400,
          color: "#444444",
          show: true,
          offsetY: -5,
        },
      },
      hollow: {
        size: "60%",
      },
    },
  },
  fill: {
    type: "solid",
    colors: ["#3699FF"],
  },
  stroke: {
    lineCap: "round",
  },
  labels: ["Progresjon"],
};

const Index = () => {
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.overview.fetchGoals.loading);
  const filter = useSelector((state) => state.overview.fetchGoals.type);
  const goalDisplay = useSelector((state) => state.overview.fetchGoals.status);

  const userLoading = useSelector(
    (state) => state.user.fetchUserDetails.loading
  );
  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  useEffect(() => {
    if (!userLoading) {
      if (selectedCompany) {
        if (!filter) {
          dispatch(setGoalType("sales"));
        } else {
          dispatch(
            retrieveGoalDisplay({ companyId: selectedCompany, filter: filter })
          );
        }
      }
    }
    if (!userLoading && !selectedCompany) {
      dispatch(resetGoalDisplay());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompany, userLoading, filter]);

  const renderData = () => {
    if (!loading && selectedCompany) {
      return (
        <Chart
          options={options}
          series={[(goalDisplay && goalDisplay.progress) || 0]}
          type="radialBar"
          width="100%"
          height="250px"
        />
      );
    } else {
      if (!loading && !selectedCompany && !userLoading) {
        return (
          <Chart
            options={options}
            series={[0]}
            type="radialBar"
            width="100%"
            height="250px"
          />
        );
      } else {
        return (
          <div className="loading-container">
            <MoonLoader
              css={"margin: 0 auto;"}
              size={40}
              color={"#123abc"}
              loading={true}
            />
          </div>
        );
      }
    }
  };

  const clickAddGoal = () => {
    dispatch(changeOverviewModal({ addGoalModal: true }));
  };

  const clickEditModal = () => {
    dispatch(changeOverviewModal({ editGoalModal: true }));

    const startDate = moment.unix(goalDisplay.data.start);
    const endDate = moment.unix(goalDisplay.data.end);
    dispatch(
      setActiveUpdateGoal({
        amount: goalDisplay.data.amount,
        start: startDate.format("yyyy-MM-DD"),
        end: endDate.format("yyyy-MM-DD"),
      })
    );
  };

  const renderButton = () => {
    if (!userLoading && !loading) {
      if (!selectedCompany) {
        return (
          <button disabled className="edit-button">
            Ikke tilgjengelig
          </button>
        );
      } else {
        if (goalDisplay) {
          return (
            <button onClick={() => clickEditModal()} className="edit-button">
              <i class="fad fa-pencil-alt"></i> Endre mål
            </button>
          );
        } else {
          return (
            <button onClick={() => clickAddGoal()} className="edit-button">
              <i class="fad fa-plus"></i> Nytt mål
            </button>
          );
        }
      }
    } else {
      return (
        <button className="edit-button">
          <i class="fas fa-circle-notch fa-spin"></i> Laster..
        </button>
      );
    }
  };

  return (
    <div className="goals-details-container">
      <Text>
        Sett opp mål på salg, leveranser og nye kunder slik at du kan holde seg
        selv motivert og følge progresjonen.
      </Text>
      <div className="chart-container">{renderData()}</div>
      {renderButton()}
    </div>
  );
};

export default Index;
